import React from "react";
import { FiExternalLink, FiInfo } from "react-icons/fi";
import { FaTicketAlt } from "react-icons/fa";

import { getNewsTypeLabel } from "../../utils/utils";
import {
  ArticleContent,
  ArticleText,
  ArticleTags,
  Tag,
  ActionButtons,
  ActionBtn,
  EmptyState,
  EmptyStateIcon,
  EmptyStateText,
} from "../../screens/Portal/NewsDetailsPage/NewsDetailsPage.styles";

/*
 * Telo novosti, sadržaj + tagovi + CTA dugmad, tačno kako se prikazuje
 * na javnoj detalj stranici (/novost/:id). Deli se između NewsDetailsPage
 * i admin pregleda u formi novosti, pa je admin preview uvek identičan
 * onome što posetioci vide.
 * - onTagClick je opcion, bez njega tagovi nisu klikabilni (admin pregled)
 */

/* Ručni prelomi reda i razmaci iz editora se čuvaju (pre-wrap), a prelomi
   koji su samo formatiranje HTML-a uz blok tagove se uklanjaju da naslovi,
   liste i paragrafi ne dobiju duple prazne redove */
const BLOCK_TAGS = "(?:h[1-6]|p|ul|ol|li|blockquote)";
const prepareContentHtml = (html) =>
  String(html)
    .replace(new RegExp(`[ \\t]*\\n+[ \\t]*(<\\/?${BLOCK_TAGS}\\b)`, "gi"), "$1")
    .replace(
      new RegExp(`(<\\/?${BLOCK_TAGS}[^>]*>)[ \\t]*\\n+[ \\t]*`, "gi"),
      "$1",
    );

const NewsArticleBody = ({ news, onTagClick }) => {
  const tags = [
    news.band?.name,
    news.festival?.name,
    getNewsTypeLabel(news.type),
    news.location,
  ].filter(Boolean);

  return (
    <ArticleContent>
      {news.content ? (
        <ArticleText
          style={{ whiteSpace: "pre-wrap" }}
          dangerouslySetInnerHTML={{
            __html: prepareContentHtml(news.content),
          }}
        />
      ) : news.text ? (
        <ArticleText style={{ whiteSpace: "pre-wrap" }}>
          {news.text}
        </ArticleText>
      ) : (
        <EmptyState>
          <EmptyStateIcon>
            <FiInfo />
          </EmptyStateIcon>
          <EmptyStateText>
            Nema dodatnih informacija za ovu novost
          </EmptyStateText>
        </EmptyState>
      )}

      {/* Tagovi → link na filtriranu listu (v2 s.10.3) */}
      {tags.length > 0 && (
        <ArticleTags>
          {tags.map((tag) =>
            onTagClick ? (
              <Tag
                key={tag}
                as="button"
                type="button"
                style={{ cursor: "pointer" }}
                onClick={() => onTagClick(tag)}
              >
                {tag}
              </Tag>
            ) : (
              <Tag key={tag}>{tag}</Tag>
            ),
          )}
        </ArticleTags>
      )}

      {/* CTA prema stvarnoj destinaciji, bez "Opširnije" (v2 s.10.4) */}
      {(news.externalLink || news.ticketLink) && (
        <ActionButtons>
          {news.ticketLink && (
            <ActionBtn
              $primary
              onClick={() =>
                window.open(news.ticketLink, "_blank", "noopener,noreferrer")
              }
            >
              <FaTicketAlt />
              Karte
            </ActionBtn>
          )}
          {news.externalLink && (
            <ActionBtn
              onClick={() =>
                window.open(news.externalLink, "_blank", "noopener,noreferrer")
              }
            >
              <FiExternalLink />
              {news.type === "festival"
                ? "Zvaničan sajt festivala"
                : "Zvaničan sajt"}
            </ActionBtn>
          )}
        </ActionButtons>
      )}
    </ArticleContent>
  );
};

export default NewsArticleBody;
